











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'description' })
export default class DescriptionComponent extends Vue {
  @Prop({ required: true }) public label!: string;
}
